<template>
  <div id="dialog-consulting-case">
    <v-dialog max-width="400px" scrollable v-model="dialogItem">
      <template v-slot:activator="{ on }">
        <v-btn @click="addItem()" color="primary" dark v-on="on">Create</v-btn>
      </template>
      <v-card>
        <!-- <v-card-title>
          <h1 class="title head-page">Counsulting Topic</h1>
        </v-card-title>-->
        <v-divider></v-divider>
        <v-card-text>
          <v-container grid-list-xs>
            <v-layout align-center justify-center row wrap>
              <v-flex xs12>
                <v-text-field clearable label="Name" v-model="formData.name"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <base-delete-button :idx="formData.idx" module="WordingType"></base-delete-button>
          <v-spacer></v-spacer>
          <v-btn @click.stop="dialogItem = !dialogItem" color dark>Close</v-btn>
          <v-btn :loading="dialogLoading" @click.prevent="doSubmit()" color="green" dark
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'dialog-consulting-case',
  data() {
    return {
      formData: [],
      dialogLoading: false,
      menuStartTime: false,
      menuEndTime: false,
      weekDays: [
        {
          idx: 1,
          name: 'อาทิตย์ (Sunday)'
        },
        {
          idx: 2,
          name: 'จันทร์ (Monday)'
        },
        {
          idx: 3,
          name: 'อังคาร (Tuesday)'
        },
        {
          idx: 4,
          name: 'พุธ (Wednesday)'
        },
        {
          idx: 5,
          name: 'พฤหัส (Thursday)'
        },
        {
          idx: 6,
          name: 'ศุกร์ (Firday)'
        },
        {
          idx: 7,
          name: 'เสาร์ (Saturday)'
        }
      ]
    }
  },
  watch: {
    dialogItem() {
      if (this.$store.state.WordingType.idx) {
        this.formData = this.$store.getters['WordingType/getAll'].filter(
          item => item.idx == this.$store.state.WordingType.idx
        )[0]
      } else {
        this.formData = []
      }
    }
  },
  computed: {
    regions() {
      return this.$store.getters['Place/getRegionAll']
    },
    dialogItem: {
      // getter
      get() {
        return this.$store.state.WordingType.dialog
      },
      // setter
      set(newValue) {
        this.$store.commit('WordingType/UPDATE_DIALOG', newValue)
      }
    }
  },
  created() {},
  methods: {
    async doSubmit() {
      try {
        const validate = await this.$validator.validateAll()
        if (validate) {
          this.dialogLoading = !this.dialogLoading
          const data = {
            ...this.formData,
            createdBy: localStorage.getItem('tokenAdmin')
          }
          await this.$store.dispatch(`WordingType/insert`, data)
          this.$store.commit(`WordingType/UPDATE_DIALOG`, false)
          this.formData = []
          this.dialogLoading = !this.dialogLoading
        }
      } catch (error) {
        throw new Error(error)
      }
    },
    addItem() {
      this.$store.commit('WordingType/UPDATE_DIALOG', true)
      this.$store.commit('WordingType/SET_IDX', null)
    }
  }
}
</script>

<style lang="scss" scoped></style>
